import auth from '@/router/auth'
import PromotionIndex from '@/components/specializeds/Index'
import PromotionCreate from '@/components/specializeds/Create'
import PromotionUpdate from '@/components/specializeds/Update'
import PromotionShow from '@/components/specializeds/Show'

export default [
  {
    path: '/specializeds',
    name: 'specializeds-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/facults/:facult_id/specializeds/create',
    name: 'specializeds-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/facults/:facult_id/specializeds/update/:specialized_id',
    name: 'specializeds-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/facults/:facult_id/specializeds/show/:specialized_id',
    name: 'specializeds-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/specializeds/router.js